import { render, staticRenderFns } from "./FrHeader.vue?vue&type=template&id=6aabce79&scoped=true&"
import script from "./FrHeader.vue?vue&type=script&lang=js&"
export * from "./FrHeader.vue?vue&type=script&lang=js&"
import style0 from "./FrHeader.vue?vue&type=style&index=0&id=6aabce79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aabce79",
  null
  
)

export default component.exports